"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackMessage = FeedbackMessage;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css");

require("@ta-interaktiv/semantic-ui/semantic/dist/components/message.css");

require("@ta-interaktiv/semantic-ui/semantic/dist/components/list.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MESSAGES = {
  de: {
    question: 'Haben Sie Anmerkungen oder einen Fehler entdeckt?',
    call: 'Wir freuen uns über Ihre Nachricht an'
  },
  fr: {
    question: 'Avez-vous des remarques ou avez-vous découvert une erreur?',
    call: 'Nous nous réjouissons de votre message à'
  }
  /**
   * React component that renders a message with a mail address allowing
   * readers to give feedback.
   *
   * @example
   * import React from 'react'
   * import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
   *
   * class YourComponent extends React.Component {
   *  render() {
   *
   *    return (
   *      <FeedbackMessage mailTo='test@example.com' className='small blue' />
   *    )
   *  }
   * }
   *
   * @param {object} props
   * @param {string} [props.mailTo=interaktiv@tages-anzeiger.ch] The mail
   *   address to send the feedback to. Join several addresses with `,`
   * @param {string} [props.project=window.document.title] The name of the
   * project. Used as the mail subject. Defaults to the window title.
   * @param {string} [props.className] Additional CSS classes that should be
   * passed to both the `ui message`.
   * @param {boolean} [props.inverted=false] Whether the component should be
   * displayed as inverted.
   * @param {string} [props.question='Haben sie Anmerkungen oder einen Fehler
   * entdeckt?' | 'Avez-vous des remarques ou avez-vous découvert une erreur?']
   * Header line of the feedback message box.
   * @param {string} [props.call='Wir freuen uns über Ihre Nachricht an' | 'Nous
   * nous réjouissons de votre message à']
   * Second part of the message, prepended to the mailTo address(es)
   * @param {'de' | 'fr'} [props.locale=de] The language in which the
   * component should be rendered. This only affects the default text strings
   */

};

function FeedbackMessage(props) {
  /**
   * Returns a translated string – or the prop when it's defined
   * @param key
   * @returns {string|Array<string>}
   * @private
   */
  var t = function t(key) {
    return props[key] || key.split('.').reduce(function (messageList, prop) {
      return messageList.hasOwnProperty(prop) ? messageList[prop] : 'TRANSLATED_STRING_NOT_FOUND: ' + key;
    }, MESSAGES[props.locale || 'de']);
  };

  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$inverted = props.inverted,
      inverted = _props$inverted === void 0 ? false : _props$inverted,
      _props$mailTo = props.mailTo,
      mailTo = _props$mailTo === void 0 ? 'interaktiv@tamedia.ch' : _props$mailTo,
      _props$project = props.project,
      project = _props$project === void 0 ? window.document.title : _props$project;
  var invertedClass = inverted ? 'inverted' : '';
  return _react.default.createElement("div", {
    className: "ui ".concat(className, " ").concat(invertedClass, " message feedback-message")
  }, _react.default.createElement("div", {
    className: "ui ".concat(invertedClass, " list")
  }, _react.default.createElement("div", {
    className: "item"
  }, _react.default.createElement("i", {
    className: "comments icon"
  }), _react.default.createElement("div", {
    className: "content"
  }, _react.default.createElement("div", {
    className: "header"
  }, t('question')), t('call'), ' ', _react.default.createElement("a", {
    href: "mailto:".concat(encodeURIComponent(mailTo), "?subject=").concat(encodeURIComponent(project))
  }, mailTo.split(',').join(', ')), "."))));
}

var _default = FeedbackMessage;
exports.default = _default;